import React from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { StravaConnection } from 'src/component/profile/connections/strava-connection'

export const ProfileConnectionsScreen = (): React.ReactElement => {
  return (
    <PageContainer>
      <div className="py-6 lg:py-[82px]">
        <h2 className="text-2xl font-bold mb-6">Connected Apps</h2>
        <div className="grid grid-cols-1 gap-5">
          <StravaConnection />
        </div>
      </div>
    </PageContainer>
  )
}
